var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_587_133",
    maskUnits: "userSpaceOnUse",
    x: 2.5,
    y: 4,
    width: 15,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2.5,
    y: 4,
    width: 15,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5H3.5V13.6304H11.5L13.5 16.5V13.6304H16.5V5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5V4H2.5V5H3.5ZM16.5 5H17.5V4H16.5V5ZM16.5 13.6304V14.6304H17.5V13.6304H16.5ZM3.5 13.6304H2.5V14.6304H3.5V13.6304ZM11.5 13.6304L12.3204 13.0586L12.022 12.6304H11.5V13.6304ZM13.5 13.6304V12.6304H12.5V13.6304H13.5ZM13.5 16.5L12.6796 17.0718C12.9294 17.4302 13.3829 17.585 13.7997 17.454C14.2164 17.3231 14.5 16.9368 14.5 16.5H13.5ZM3.5 6H16.5V4H3.5V6ZM15.5 5V13.6304H17.5V5H15.5ZM4.5 13.6304V5H2.5V13.6304H4.5ZM11.5 12.6304H3.5V14.6304H11.5V12.6304ZM16.5 12.6304H13.5V14.6304H16.5V12.6304ZM12.5 13.6304V16.5H14.5V13.6304H12.5ZM14.3204 15.9282L12.3204 13.0586L10.6796 14.2022L12.6796 17.0718L14.3204 15.9282Z",
    fill: "#AEAEAE",
    mask: "url(#path-1-outside-1_587_133)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.1ed08937de73c10ee6a335ae200f00cf.svg";
export { ForwardRef as ReactComponent };